import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/ui/utils";
import { NavButton } from "@repo/ui/nav-button";
import type { FloatingNavItem } from "./floating-nav.types";
import { Icon } from "@repo/ui/icon";
interface NavBarProps {
  headline?: string;
  items: FloatingNavItem[];
  activeId: string | null;
  onToggle: () => void;
  onNavClick: (targetId: string) => void;
  onScrollToTop: () => void;
}

/**
 * Desktop horizontal bar + Mobile closed bar.
 * Renders differently per breakpoint using responsive classes.
 */
export function NavBar(t0) {
  const $ = _c(36);
  const {
    headline,
    items,
    activeId,
    onToggle,
    onNavClick,
    onScrollToTop
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("relative mx-auto max-w-fit", "bg-grey-50/95 backdrop-blur-[5px]", "rounded-sm", "border border-border-subtle", "shadow-sm");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== headline) {
    t2 = headline && <span className="typography-component-sm-medium shrink-0 text-text-secondary">{headline}</span>;
    $[1] = headline;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== headline) {
    t3 = headline && <div className="h-9 w-px bg-border-subtle" aria-hidden="true" />;
    $[3] = headline;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== activeId || $[6] !== items || $[7] !== onNavClick) {
    let t5;
    if ($[9] !== activeId || $[10] !== onNavClick) {
      t5 = item => <li key={item.targetId}><NavButton variant="item" active={item.targetId === activeId} onClick={() => onNavClick(item.targetId)}>{item.label}</NavButton></li>;
      $[9] = activeId;
      $[10] = onNavClick;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    t4 = items.map(t5);
    $[5] = activeId;
    $[6] = items;
    $[7] = onNavClick;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[12] !== t4) {
    t5 = <ul role="list" className="flex flex-1 flex-row gap-1">{t4}</ul>;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="h-9 w-px bg-border-subtle" aria-hidden="true" />;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Icon name="arrow-up" size="lg" />;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== onScrollToTop) {
    t8 = <NavButton variant="icon" onClick={onScrollToTop} aria-label="Scroll to top">{t7}</NavButton>;
    $[16] = onScrollToTop;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t2 || $[19] !== t3 || $[20] !== t5 || $[21] !== t8) {
    t9 = <div className="hidden items-center gap-4 px-3 py-2 tablet:flex">{t2}{t3}{t5}{t6}{t8}</div>;
    $[18] = t2;
    $[19] = t3;
    $[20] = t5;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const t10 = headline || "Jump to";
  let t11;
  if ($[23] !== t10) {
    t11 = <span className="typography-component-sm-medium shrink-0 px-4 py-3 text-text-primary">{t10}</span>;
    $[23] = t10;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="flex h-[39px] items-center" aria-hidden="true"><div className="h-full w-px bg-border-subtle" /></div>;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = cn("flex shrink-0 items-center justify-center rounded-full px-4 py-3", "text-text-secondary transition-colors", "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-open-water-500");
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Icon name="menu" size="lg" />;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== onToggle) {
    t15 = <button type="button" onClick={onToggle} className={t13} aria-label="Open navigation menu">{t14}</button>;
    $[28] = onToggle;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t11 || $[31] !== t15) {
    t16 = <div className="flex items-center gap-1 p-2 tablet:hidden">{t11}{t12}{t15}</div>;
    $[30] = t11;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t16 || $[34] !== t9) {
    t17 = <div className={t1}>{t9}{t16}</div>;
    $[33] = t16;
    $[34] = t9;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  return t17;
}